module.exports = __webpack_public_path__ + "img/Wonde-Icon-Colour.28751085.svg";